import { Link } from 'react-router-dom';

export default function PopularSection() {
  const restaurants = [
    {
      name: 'La Table du Quartier',
      category: 'Cuisine française',
      rating: 4.8,
      reviews: 245,
      deliveryTime: '25-35 min',
      image: 'https://public.readdy.ai/ai/img_res/aeaa2f5b49af053f8831ae15b85e7239.jpg'
    },
    {
      name: 'Sushi Sakura',
      category: 'Japonais',
      rating: 4.9,
      reviews: 189,
      deliveryTime: '30-40 min',
      image: 'https://readdy.ai/api/search-image?query=fresh%20sushi%20platter%20with%20colorful%20nigiri%20sashimi%20and%20maki%20rolls%20arranged%20on%20a%20dark%20slate%20plate%20with%20wasabi%20ginger%20and%20soy%20sauce%20featuring%20vibrant%20salmon%20tuna%20and%20vegetables%20in%20professional%20food%20photography%20style%20with%20clean%20background%20and%20natural%20lighting&width=400&height=300&seq=rest-localygo-002&orientation=landscape'
    },
    {
      name: 'Pizza Bella',
      category: 'Italien',
      rating: 4.7,
      reviews: 312,
      deliveryTime: '20-30 min',
      image: 'https://readdy.ai/api/search-image?query=authentic%20italian%20pizza%20with%20fresh%20mozzarella%20basil%20and%20tomatoes%20on%20a%20wooden%20board%20featuring%20melted%20cheese%20colorful%20toppings%20and%20crispy%20crust%20in%20rustic%20trattoria%20style%20with%20warm%20lighting%20and%20appetizing%20presentation%20showcasing%20traditional%20italian%20cuisine&width=400&height=300&seq=rest-localygo-003&orientation=landscape'
    },
    {
      name: 'Le Jardin Végétal',
      category: 'Végétarien',
      rating: 4.6,
      reviews: 156,
      deliveryTime: '25-35 min',
      image: 'https://readdy.ai/api/search-image?query=vibrant%20vegetarian%20buddha%20bowl%20with%20colorful%20fresh%20vegetables%20quinoa%20avocado%20chickpeas%20and%20tahini%20dressing%20arranged%20artistically%20in%20a%20ceramic%20bowl%20featuring%20green%20leafy%20vegetables%20purple%20cabbage%20orange%20carrots%20in%20healthy%20food%20photography%20style%20with%20natural%20lighting%20and%20clean%20background&width=400&height=300&seq=rest-localygo-004&orientation=landscape'
    }
  ];

  const boutiques = [
    {
      name: 'Boulangerie Martin',
      category: 'Boulangerie',
      rating: 4.9,
      reviews: 423,
      deliveryTime: '15-25 min',
      image: 'https://readdy.ai/api/search-image?query=artisan%20bakery%20display%20with%20fresh%20golden%20croissants%20baguettes%20and%20pastries%20arranged%20on%20wooden%20shelves%20featuring%20rustic%20bread%20varieties%20colorful%20pastries%20in%20warm%20cozy%20bakery%20atmosphere%20with%20soft%20lighting%20and%20flour%20dust%20showcasing%20traditional%20french%20baking&width=400&height=300&seq=shop-localygo-001&orientation=landscape'
    },
    {
      name: 'Épicerie Bio du Coin',
      category: 'Épicerie bio',
      rating: 4.7,
      reviews: 198,
      deliveryTime: '20-30 min',
      image: 'https://readdy.ai/api/search-image?query=organic%20grocery%20store%20display%20with%20fresh%20colorful%20fruits%20vegetables%20and%20natural%20products%20in%20wooden%20crates%20and%20wicker%20baskets%20featuring%20green%20leafy%20vegetables%20red%20tomatoes%20orange%20citrus%20in%20modern%20eco-friendly%20shop%20atmosphere%20with%20natural%20lighting%20and%20rustic%20decoration&width=400&height=300&seq=shop-localygo-002&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-3">
                Restaurants populaires
              </h2>
              <p className="text-lg text-gray-600">
                Les établissements préférés des utilisateurs Localygo
              </p>
            </div>
            <Link 
              to="/restaurants" 
              className="hidden md:block text-teal-600 font-semibold hover:text-teal-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Voir tout <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {restaurants.map((restaurant, index) => (
              <div 
                key={index}
                className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-shadow cursor-pointer border border-gray-100"
              >
                <div className="relative w-full h-48">
                  <img 
                    src={restaurant.image}
                    alt={restaurant.name}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-3 right-3 bg-white rounded-full px-3 py-1 flex items-center space-x-1">
                    <i className="ri-star-fill text-yellow-400 text-sm"></i>
                    <span className="text-sm font-semibold text-gray-900">{restaurant.rating}</span>
                  </div>
                </div>
                
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-gray-900 mb-1">
                    {restaurant.name}
                  </h3>
                  <p className="text-sm text-gray-600 mb-3">{restaurant.category}</p>
                  
                  <div className="flex items-center justify-between text-xs text-gray-500">
                    <span className="flex items-center">
                      <i className="ri-time-line mr-1"></i>
                      {restaurant.deliveryTime}
                    </span>
                    <span>{restaurant.reviews} avis</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <Link 
            to="/restaurants" 
            className="md:hidden block text-center text-teal-600 font-semibold hover:text-teal-700 transition-colors mt-6 cursor-pointer"
          >
            Voir tous les restaurants <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div>
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-3">
                Boutiques locales
              </h2>
              <p className="text-lg text-gray-600">
                Découvrez les commerces de proximité
              </p>
            </div>
            <Link 
              to="/boutiques" 
              className="hidden md:block text-teal-600 font-semibold hover:text-teal-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Voir tout <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {boutiques.map((boutique, index) => (
              <div 
                key={index}
                className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-shadow cursor-pointer border border-gray-100"
              >
                <div className="flex flex-col md:flex-row">
                  <div className="relative w-full md:w-48 h-48">
                    <img 
                      src={boutique.image}
                      alt={boutique.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  
                  <div className="flex-1 p-6">
                    <div className="flex items-start justify-between mb-2">
                      <h3 className="text-xl font-semibold text-gray-900">
                        {boutique.name}
                      </h3>
                      <div className="flex items-center space-x-1 bg-gray-50 rounded-full px-3 py-1">
                        <i className="ri-star-fill text-yellow-400 text-sm"></i>
                        <span className="text-sm font-semibold text-gray-900">{boutique.rating}</span>
                      </div>
                    </div>
                    
                    <p className="text-sm text-gray-600 mb-4">{boutique.category}</p>
                    
                    <div className="flex items-center justify-between text-sm text-gray-500">
                      <span className="flex items-center">
                        <i className="ri-time-line mr-1"></i>
                        {boutique.deliveryTime}
                      </span>
                      <span>{boutique.reviews} avis</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <Link 
            to="/boutiques" 
            className="md:hidden block text-center text-teal-600 font-semibold hover:text-teal-700 transition-colors mt-6 cursor-pointer"
          >
            Voir toutes les boutiques <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
